import { WifiOff } from "lucide-react";

import { useOnlineStatus } from "@/hooks/useOnlineStatus";

/** Non-blocking strip when the device loses connectivity. */
export function OfflineBanner() {
  const online = useOnlineStatus();
  if (online) return null;

  return (
    <div
      role="status"
      className="flex items-center justify-center gap-2 border-b border-amber-500/30
        bg-amber-500/10 px-4 py-2 text-xs font-medium text-amber-800 dark:text-amber-200"
    >
      <WifiOff className="h-3.5 w-3.5 shrink-0" aria-hidden />
      You&apos;re offline — showing cached data. Changes sync when you reconnect.
    </div>
  );
}
